/** @jsxImportSource @emotion/react */
import { jsx, css, keyframes } from "@emotion/react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Grid,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Table,
  TableCell,
  Paper,
  Box,
  Tab,
  Divider,
} from "@mui/material";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ReactComponent as Birthday } from "../assets/birthday.svg";
import { ReactComponent as Class5 } from "../assets/class5.svg";
import { ReactComponent as Pass1 } from "../assets/pass1.svg";
import { ReactComponent as Pass2 } from "../assets/pass2.svg";
import { ReactComponent as Pass4 } from "../assets/pass4.svg";
import { ReactComponent as Pass8 } from "../assets/pass8.svg";
import axios from "axios";
import get_token from "../lib/get_token";
import React, { useEffect, useState } from "react";
import { configState } from "../lib/State";
import get_cid from "../lib/get_cid";

const tab2Theme = createTheme({
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&&.Mui-selected": {
            fontWeight: "bold",
            color: "black",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: "black",
        },
        indicator: {
          display: "none",
        },
        flexContainer: {
          color: "red",
        },
        scroller: {
          color: "red",
        },
      },
    },
  },
});

function MemberLevel(props) {
  const { login } = props;
  const cid = get_cid();
  const [tab, setTab] = useState("1");
  const [membership, setMembership] = useState('-');

  const memberChange = (e, newValue) => {
    setTab(newValue);
  };

  const load_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(configState.api + "/gympass/home_membership", postData);
    setMembership(result.data.count);
  };

  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    <Grid
      container
      // height="100vh"
      width="100%"
      direction="column"
      justifyContent="center"
    // alignItems="center"
    >
      <Box
        sx={{
          margin: "20px 0 20px 20px",
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            marginBottom: "14px",
          }}
        >
          멤버십 등급
        </Box>
        {membership <= 60 ?
          <Box
            sx={{
              fontSize: "22px",
              fontWeight: "bold",
              color: "#7a7a7a",
            }}
          >
            Silver
          </Box>
          :
          <Box
            sx={{
              fontSize: "22px",
              fontWeight: "bold",
              color: "#dbc93f",
            }}
          >
            Gold
          </Box>
        }

      </Box>
      <Divider />

      <Box
        sx={{
          margin: "20px 0 20px 20px",
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            marginBottom: "14px",
          }}
        >
          등급별 조건
        </Box>
        <Box
          sx={{
            fontSize: "14px",
            // fontWeight: 'bold',
            // color: ''
          }}
        >
          최초 가입 시 Silver 등급을 부여받습니다.
          <br></br>
          클래스쿠폰 누적 60회 이상 구매시 Gold 등급이 될 수 있습니다.
        </Box>
      </Box>
      <Divider />

      <Box
        sx={{
          margin: "20px 20px 20px 20px",
        }}
      >
        <Box
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          등급별 혜택
        </Box>
        <Box
          sx={{
            width: "100%",
          }}
        >
          <ThemeProvider theme={tab2Theme}>
            <TabContext value={tab}>
              <TabList onChange={memberChange} sx={{ mt: 1 }}>
                <Tab label="Silver" value="1" />
                <Tab label="Gold" value="2" sx={{ borderLeft: '1px solid rgba(0, 0, 0, 0.3)', color: '#cccccc' }} />
              </TabList>
              <TabPanel
                value="1"
                sx={{
                  width: "100%",
                  padding: 0,
                }}
              >
                <Box
                  sx={{
                    marginBottom: "10px",
                  }}
                >
                  {/* Silver 등급은 클래스 쿠폰 구입 60회 미만 */}
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Class5 />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    회원 가입시 클래스 체험쿠폰 증정
                  </Box>
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Birthday />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    생일 쿠폰 증정
                  </Box>
                </Box>
              </TabPanel>
              <TabPanel
                value="2"
                sx={{
                  width: "100%",
                  padding: 0,
                }}
              >
                <Box
                  sx={{
                    marginBottom: "10px",
                  }}
                >
                  {/* Gold 등급은 클래스 쿠폰 구입 60회 이상 */}
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Birthday />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    생일 쿠폰 증정
                  </Box>
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Pass1 />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    클래스쿠폰 4회권 구매시
                    <br></br>
                    패스쿠폰 1회권 무료 증정
                  </Box>
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Pass2 />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    클래스쿠폰 8회권 구매시
                    <br></br>
                    패스쿠폰 2회권 무료 증정
                  </Box>
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Pass4 />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    클래스쿠폰 30회권 구매시
                    <br></br>
                    패스쿠폰 4회권 무료 증정
                  </Box>
                </Box>
                <Box
                  sx={{
                    background: "#f0efed",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      minWidth: "48px",
                      width: "48px",
                      height: "48px",
                      margin: "10px 20px 15px 20px",
                      fontWeight: "bold",
                    }}
                  >
                    <Pass8 />
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    클래스쿠폰 60회권 구매시
                    <br></br>
                    패스쿠폰 8회권 무료 증정
                  </Box>
                </Box>
              </TabPanel>
            </TabContext>
          </ThemeProvider>
        </Box>
      </Box>
      {/* <TableContainer component={Paper} sx={{ width: "90%", marginBottom: '20px' }}>
                <Table sx={{ borderTop: "1px solid gray" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ padding: 0, textAlign: "center", width: "50%" }}><Box sx={{background: "gray", color: "white"}}>Silver</Box></TableCell>
                            <TableCell sx={{ padding: 0, textAlign: "center", width: "50%" }}><Box sx={{background: "#F7C00B", color: "white"}}>Gold</Box></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ padding: "5px", textAlign: "center", fontSize: '12px' }}>60회 미만</TableCell>
                            <TableCell sx={{ padding: "5px", textAlign: "center", fontSize: '12px' }}>60회 이상 등록</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ padding: "5px", textAlign: "center", fontSize: '12px' }}>
                                가입시 1회 클래스쿠폰 제공
                                <br></br>
                                (무료 체험 5회 이용권)
                            </TableCell>
                            <TableCell sx={{ padding: "5px", textAlign: "center", fontSize: '12px' }}>
                                4회권 : 패스쿠폰 1장
                                <br></br>
                                8회권 : 패스쿠폰 2장
                                <br></br>
                                30회권 : 패스쿠폰 4장
                                <br></br>
                                60회권 : 패스쿠폰 8장
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer> */}
    </Grid>
  );
}

export default MemberLevel;
